{
  "level": "do09",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:do09",
    "objects": "AREAS.E3:do09.e3",
    "mesh": "TREES.E3:do09.e3"
  },
  "spawn_point": {
    "position": [
      113.0429796854655,
      1288.9245869954427,
      84.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      113.0429796854655,
      1388.9245869954427,
      84.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -429.4999084472656,
      1123.759033203125,
      60.0
    ],
    "bbox_max": [
      535.7269287109375,
      1490.0,
      400.0
    ],
    "vertex_count": 60,
    "vertices": [
      [
        120.0,
        1490.0,
        60.0
      ],
      [
        0.0,
        1490.0,
        60.0
      ],
      [
        120.0,
        1490.0,
        120.0
      ],
      [
        120.0,
        1490.0,
        60.0
      ],
      [
        120.0,
        1490.0,
        120.0
      ],
      [
        120.0,
        1490.0,
        140.0
      ],
      [
        260.0,
        1490.0,
        60.0
      ],
      [
        260.0,
        1490.0,
        120.0
      ],
      [
        535.7269287109375,
        1207.4046630859375,
        80.0
      ],
      [
        505.25732421875,
        1268.8197021484375,
        80.0
      ],
      [
        260.0,
        1459.0001220703125,
        78.0
      ],
      [
        395.0,
        1459.0001220703125,
        78.0
      ],
      [
        480.0,
        1239.9998779296875,
        80.0
      ],
      [
        480.0,
        1240.9998779296875,
        78.0
      ],
      [
        480.0,
        1240.9998779296875,
        78.0
      ],
      [
        500.0,
        1240.9998779296875,
        78.0
      ],
      [
        440.0,
        1230.9998779296875,
        98.0
      ],
      [
        460.0,
        1230.9998779296875,
        98.0
      ],
      [
        340.0,
        1240.9998779296875,
        78.0
      ],
      [
        260.0,
        1240.9998779296875,
        78.0
      ],
      [
        440.0,
        1240.0,
        98.0
      ],
      [
        460.0,
        1240.0,
        98.0
      ],
      [
        262.6665954589844,
        1309.0,
        78.0
      ],
      [
        260.0,
        1309.0,
        78.0
      ],
      [
        262.6666259765625,
        1309.0,
        78.0
      ],
      [
        400.0,
        1309.0,
        78.0
      ],
      [
        500.0,
        1309.0,
        78.0
      ],
      [
        480.0,
        1309.0001220703125,
        78.0
      ],
      [
        270.0,
        1416.0,
        78.0
      ],
      [
        270.0,
        1309.0,
        78.0
      ],
      [
        270.0,
        1360.0,
        180.0
      ],
      [
        480.0,
        1309.0001220703125,
        78.0
      ],
      [
        480.0,
        1310.0001220703125,
        80.0
      ],
      [
        260.0,
        1280.0,
        78.0
      ],
      [
        500.0,
        1280.0,
        78.0
      ],
      [
        440.0,
        1280.0,
        98.0
      ],
      [
        460.0,
        1280.0,
        98.0
      ],
      [
        -379.50006103515625,
        1123.759033203125,
        400.0
      ],
      [
        -399.5,
        1158.39990234375,
        400.0
      ],
      [
        -279.4776611328125,
        1210.361328125,
        120.0
      ],
      [
        -279.4776611328125,
        1210.361328125,
        110.0
      ],
      [
        -279.4776611328125,
        1210.361328125,
        80.0
      ],
      [
        -279.4776611328125,
        1210.361328125,
        95.0
      ],
      [
        -279.4776611328125,
        1210.361328125,
        110.0
      ],
      [
        -279.4776611328125,
        1210.361328125,
        95.0
      ],
      [
        -429.4999084472656,
        1210.361328125,
        80.00611877441406
      ],
      [
        -406.4058837890625,
        1210.361328125,
        60.00611877441406
      ],
      [
        -295.0,
        1219.021728515625,
        80.0
      ],
      [
        -295.0,
        1219.021728515625,
        125.0
      ],
      [
        -411.4059753417969,
        1219.021728515625,
        60.00611877441406
      ],
      [
        -310.0,
        1219.021728515625,
        80.0
      ],
      [
        -295.0,
        1219.021728515625,
        80.0
      ],
      [
        -340.0,
        1219.021728515625,
        80.0
      ],
      [
        -310.0,
        1219.021728515625,
        80.0
      ],
      [
        -156.04698181152344,
        1239.021728515625,
        60.00611877441406
      ],
      [
        -299.513916015625,
        1239.02783203125,
        60.0
      ],
      [
        -295.0,
        1230.0,
        69.02511596679688
      ],
      [
        110.0,
        1250.0,
        80.0
      ],
      [
        110.0,
        1250.0,
        60.0
      ],
      [
        110.0,
        1250.0,
        80.0
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1490.0,
      "bbox_min": [
        -634.7308349609375,
        1000.0,
        60.0
      ],
      "bbox_max": [
        582.7122802734375,
        1500.0,
        500.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -59.999996185302734,
      "bbox_min": [
        0.0,
        1490.0,
        60.0
      ],
      "bbox_max": [
        260.0,
        1500.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -260.0,
      "bbox_min": [
        260.0,
        1490.0,
        60.0
      ],
      "bbox_max": [
        260.0,
        1500.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        -634.7308349609375,
        1000.0,
        60.0
      ],
      "bbox_max": [
        582.7122802734375,
        1490.0,
        500.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -260.0,
      "bbox_min": [
        120.0,
        1000.0,
        60.0
      ],
      "bbox_max": [
        582.7122802734375,
        1490.0,
        180.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -60.0,
      "bbox_min": [
        120.0,
        1205.0,
        60.0
      ],
      "bbox_max": [
        260.0,
        1345.0,
        75.0
      ],
      "face_count": 16
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 75.0,
      "bbox_min": [
        120.0,
        1205.0,
        60.0
      ],
      "bbox_max": [
        260.0,
        1345.0,
        75.0
      ],
      "face_count": 16
    },
    {
      "plane_normal": [
        0.25881069898605347,
        0.9659281373023987,
        0.0
      ],
      "plane_d": -1213.117431640625,
      "bbox_min": [
        120.0,
        1205.0,
        60.0
      ],
      "bbox_max": [
        260.0,
        1345.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1205.0,
      "bbox_min": [
        154.9998779296875,
        1205.0,
        60.0
      ],
      "bbox_max": [
        190.0,
        1214.3779296875,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        1.30167654788238e-05,
        -0.0
      ],
      "plane_d": -155.01568603515625,
      "bbox_min": [
        154.9998779296875,
        1205.0,
        60.0
      ],
      "bbox_max": [
        155.0,
        1214.3779296875,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881069898605347,
        0.9659281373023987,
        0.0
      ],
      "plane_d": -1114.7694091796875,
      "bbox_min": [
        120.0,
        1205.0,
        60.0
      ],
      "bbox_max": [
        260.0,
        1345.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1205.0,
      "bbox_min": [
        190.0,
        1205.0,
        60.0
      ],
      "bbox_max": [
        225.0001220703125,
        1214.3779296875,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        1.30167654788238e-05,
        0.0
      ],
      "plane_d": 224.98431396484375,
      "bbox_min": [
        225.0,
        1205.0,
        60.0
      ],
      "bbox_max": [
        225.0001220703125,
        1214.3779296875,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.70711350440979,
        0.7071000337600708,
        -5.754504854849074e-06
      ],
      "plane_d": -968.2886962890625,
      "bbox_min": [
        120.0,
        1214.3779296875,
        60.0
      ],
      "bbox_max": [
        260.0,
        1345.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071118354797363,
        -0.7071017026901245,
        0.0
      ],
      "plane_d": 834.8184204101562,
      "bbox_min": [
        120.0,
        1214.3779296875,
        60.0
      ],
      "bbox_max": [
        260.0,
        1345.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.70711350440979,
        0.7071000337600708,
        0.0
      ],
      "plane_d": -699.5860595703125,
      "bbox_min": [
        120.0,
        1214.3779296875,
        60.0
      ],
      "bbox_max": [
        260.0,
        1345.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.70711350440979,
        -0.7071000337600708,
        0.0
      ],
      "plane_d": 1103.51904296875,
      "bbox_min": [
        120.0,
        1230.8818359375,
        60.0
      ],
      "bbox_max": [
        260.0,
        1345.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881069898605347,
        -0.9659281373023987,
        0.0
      ],
      "plane_d": 1348.347412109375,
      "bbox_min": [
        120.0,
        1230.8818359375,
        60.0
      ],
      "bbox_max": [
        260.0,
        1345.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881069898605347,
        -0.9659281373023987,
        0.0
      ],
      "plane_d": 1249.999267578125,
      "bbox_min": [
        120.0,
        1230.8818359375,
        60.0
      ],
      "bbox_max": [
        260.0,
        1345.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659253358840942,
        -0.2588212490081787,
        -0.0
      ],
      "plane_d": 470.9080810546875,
      "bbox_min": [
        120.0,
        1230.8818359375,
        60.0
      ],
      "bbox_max": [
        260.0,
        1319.1181640625,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659253358840942,
        -0.2588212490081787,
        0.0
      ],
      "plane_d": 103.85641479492188,
      "bbox_min": [
        145.8818359375,
        1230.8818359375,
        60.0
      ],
      "bbox_max": [
        260.0,
        1319.1181640625,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881490111351013,
        -0.9659269452095032,
        -2.1062412542960374e-06
      ],
      "plane_d": 1238.1168212890625,
      "bbox_min": [
        145.8818359375,
        1230.8818359375,
        60.0
      ],
      "bbox_max": [
        234.1181640625,
        1319.1181640625,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881490111351013,
        -0.9659269452095032,
        0.0
      ],
      "plane_d": 1139.76708984375,
      "bbox_min": [
        145.8818359375,
        1230.8818359375,
        60.0
      ],
      "bbox_max": [
        234.1181640625,
        1319.1181640625,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881627202033997,
        0.9659266471862793,
        0.0
      ],
      "plane_d": -1224.996337890625,
      "bbox_min": [
        145.8818359375,
        1236.79248046875,
        60.0
      ],
      "bbox_max": [
        234.1181640625,
        1319.1181640625,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881627202033997,
        0.9659266471862793,
        -2.106252395606134e-06
      ],
      "plane_d": -1323.3463134765625,
      "bbox_min": [
        145.8818359375,
        1236.79248046875,
        60.0
      ],
      "bbox_max": [
        234.1181640625,
        1319.1181640625,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659253358840942,
        0.2588212490081787,
        0.0
      ],
      "plane_d": -189.0861358642578,
      "bbox_min": [
        145.8818359375,
        1236.79248046875,
        60.0
      ],
      "bbox_max": [
        234.1181640625,
        1313.20751953125,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659253358840942,
        0.2588212490081787,
        -0.0
      ],
      "plane_d": -556.1377563476562,
      "bbox_min": [
        151.7926025390625,
        1236.79248046875,
        60.0
      ],
      "bbox_max": [
        234.1181640625,
        1313.20751953125,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071121335029602,
        -0.7071014642715454,
        -0.0
      ],
      "plane_d": 993.290771484375,
      "bbox_min": [
        151.7926025390625,
        1236.79248046875,
        60.0
      ],
      "bbox_max": [
        228.2073974609375,
        1313.20751953125,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071121335029602,
        -0.7071014642715454,
        -5.754493940912653e-06
      ],
      "plane_d": 724.588623046875,
      "bbox_min": [
        151.7926025390625,
        1236.79248046875,
        60.0
      ],
      "bbox_max": [
        228.2073974609375,
        1313.20751953125,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071094512939453,
        0.7071041464805603,
        -5.75447211303981e-06
      ],
      "plane_d": -809.821533203125,
      "bbox_min": [
        151.7926025390625,
        1297.05908203125,
        60.0
      ],
      "bbox_max": [
        228.2073974609375,
        1313.20751953125,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071094512939453,
        0.7071041464805603,
        -0.0
      ],
      "plane_d": -1078.5234375,
      "bbox_min": [
        212.05908203125,
        1297.05908203125,
        60.0
      ],
      "bbox_max": [
        228.2073974609375,
        1313.20751953125,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659240245819092,
        0.2588256597518921,
        0.0
      ],
      "plane_d": -78.86228942871094,
      "bbox_min": [
        250.6217041015625,
        1240.0,
        60.0
      ],
      "bbox_max": [
        260.0,
        1310.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1250.0,
      "bbox_min": [
        253.30126953125,
        1250.0,
        60.0
      ],
      "bbox_max": [
        260.0,
        1250.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659240245819092,
        -0.2588256597518921,
        -0.0
      ],
      "plane_d": 581.1431274414062,
      "bbox_min": [
        250.6217041015625,
        1300.0,
        60.0
      ],
      "bbox_max": [
        260.0,
        1310.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1300.0,
      "bbox_min": [
        253.30126953125,
        1300.0,
        60.0
      ],
      "bbox_max": [
        260.0,
        1300.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.965927004814148,
        0.25881466269493103,
        -0.0
      ],
      "plane_d": -445.9000549316406,
      "bbox_min": [
        120.0,
        1240.0,
        60.0
      ],
      "bbox_max": [
        129.3782958984375,
        1310.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1250.0,
      "bbox_min": [
        120.0,
        1250.0,
        60.0
      ],
      "bbox_max": [
        126.69873046875,
        1250.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659240245819092,
        -0.2588256597518921,
        -7.860709956730716e-06
      ],
      "plane_d": 214.09259033203125,
      "bbox_min": [
        120.0,
        1300.0,
        60.0
      ],
      "bbox_max": [
        129.3782958984375,
        1310.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1300.0,
      "bbox_min": [
        120.0,
        1300.0,
        60.0
      ],
      "bbox_max": [
        126.69873046875,
        1300.0,
        75.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -60.0,
      "bbox_min": [
        260.0,
        1120.0,
        60.0
      ],
      "bbox_max": [
        582.7122802734375,
        1460.0,
        180.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 500.0,
      "bbox_min": [
        260.0,
        1120.0,
        60.0
      ],
      "bbox_max": [
        582.7122802734375,
        1460.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9510564208030701,
        0.3090174198150635,
        0.0
      ],
      "plane_d": 88.44082641601562,
      "bbox_min": [
        500.0,
        1175.6285400390625,
        80.0
      ],
      "bbox_max": [
        582.7122802734375,
        1352.5953369140625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9510564208030701,
        -0.3090174198150635,
        0.0
      ],
      "plane_d": 882.6156005859375,
      "bbox_min": [
        505.25732421875,
        1175.6285400390625,
        80.0
      ],
      "bbox_max": [
        582.7122802734375,
        1285.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5877842307090759,
        -0.8090178370475769,
        0.0
      ],
      "plane_d": 1301.7037353515625,
      "bbox_min": [
        530.4696044921875,
        1175.6285400390625,
        80.0
      ],
      "bbox_max": [
        582.7122802734375,
        1223.5849609375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5257307887077332,
        -0.72360759973526,
        0.4472127854824066
      ],
      "plane_d": 1119.5582275390625,
      "bbox_min": [
        530.4696044921875,
        1175.6285400390625,
        80.0
      ],
      "bbox_max": [
        582.7122802734375,
        1223.5849609375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8506508469581604,
        -0.27639344334602356,
        0.44721344113349915
      ],
      "plane_d": 744.7139282226562,
      "bbox_min": [
        505.25732421875,
        1207.4046630859375,
        80.0
      ],
      "bbox_max": [
        535.7269287109375,
        1285.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8506506085395813,
        0.2763933539390564,
        0.44721394777297974
      ],
      "plane_d": 34.38275146484375,
      "bbox_min": [
        500.0,
        1268.8197021484375,
        80.0
      ],
      "bbox_max": [
        530.4696044921875,
        1352.5953369140625,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8506508469581604,
        -0.27639344334602356,
        0.44721344113349915
      ],
      "plane_d": 744.7139282226562,
      "bbox_min": [
        500.0,
        1268.8197021484375,
        80.0
      ],
      "bbox_max": [
        510.5146179199219,
        1285.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1460.0,
      "bbox_min": [
        260.0,
        1120.0,
        60.0
      ],
      "bbox_max": [
        500.0,
        1460.0,
        180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 1270.0867919921875,
      "bbox_min": [
        260.0,
        1120.0,
        60.0
      ],
      "bbox_max": [
        500.0,
        1460.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        260.0,
        1459.0001220703125,
        78.0
      ],
      "bbox_max": [
        395.0,
        1460.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -1144.86669921875,
      "bbox_min": [
        260.0,
        1120.0,
        60.0
      ],
      "bbox_max": [
        500.0,
        1459.0001220703125,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 480.0,
      "bbox_min": [
        260.0,
        1120.0,
        78.0
      ],
      "bbox_max": [
        500.0,
        1240.9998779296875,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        480.0,
        1140.0,
        78.0
      ],
      "bbox_max": [
        500.0,
        1240.9998779296875,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        260.0,
        1130.0,
        78.0
      ],
      "bbox_max": [
        460.0,
        1240.9998779296875,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        260.0,
        1240.0,
        78.0
      ],
      "bbox_max": [
        340.0,
        1240.9998779296875,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1240.0,
      "bbox_min": [
        260.0,
        1230.9998779296875,
        60.0
      ],
      "bbox_max": [
        500.0,
        1459.0001220703125,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        440.0,
        1230.9998779296875,
        98.0
      ],
      "bbox_max": [
        460.0,
        1240.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 1135.922607421875,
      "bbox_min": [
        260.0,
        1239.9998779296875,
        60.0
      ],
      "bbox_max": [
        500.0,
        1459.0001220703125,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        260.0,
        1300.0,
        60.0
      ],
      "bbox_max": [
        500.0,
        1459.0001220703125,
        180.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1440.0,
      "bbox_min": [
        260.0,
        1309.0,
        78.0
      ],
      "bbox_max": [
        480.0,
        1440.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 270.0,
      "bbox_min": [
        270.0,
        1309.0,
        78.0
      ],
      "bbox_max": [
        480.0,
        1430.0,
        180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 480.0,
      "bbox_min": [
        480.0,
        1309.0001220703125,
        78.0
      ],
      "bbox_max": [
        480.0,
        1430.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 269.9999694824219,
      "bbox_min": [
        270.0,
        1300.0,
        60.0
      ],
      "bbox_max": [
        270.0,
        1425.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        260.0,
        1239.9998779296875,
        78.0
      ],
      "bbox_max": [
        500.0,
        1360.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1280.0,
      "bbox_min": [
        260.0,
        1239.9998779296875,
        78.0
      ],
      "bbox_max": [
        500.0,
        1310.0001220703125,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        260.0,
        1280.0,
        78.0
      ],
      "bbox_max": [
        500.0,
        1310.0001220703125,
        98.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        440.0,
        1280.0,
        78.0
      ],
      "bbox_max": [
        480.0,
        1310.0001220703125,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 480.0,
      "bbox_min": [
        480.0,
        1300.0,
        78.0
      ],
      "bbox_max": [
        480.0,
        1310.0001220703125,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        260.0,
        1239.9998779296875,
        78.0
      ],
      "bbox_max": [
        500.0,
        1280.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        440.0,
        1239.9998779296875,
        78.0
      ],
      "bbox_max": [
        480.0,
        1280.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 480.0,
      "bbox_min": [
        480.0,
        1239.9998779296875,
        78.0
      ],
      "bbox_max": [
        480.0,
        1280.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -60.0,
      "bbox_min": [
        -634.7308349609375,
        1050.0,
        60.0
      ],
      "bbox_max": [
        120.0,
        1490.0,
        500.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.8660256266593933,
        0.4999997317790985,
        -0.0
      ],
      "plane_d": -233.222412109375,
      "bbox_min": [
        -504.5,
        1101.0794677734375,
        60.0
      ],
      "bbox_max": [
        -144.5,
        1240.0,
        500.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1219.021728515625,
      "bbox_min": [
        -504.5,
        1123.759033203125,
        80.00611877441406
      ],
      "bbox_max": [
        -379.50006103515625,
        1219.021728515625,
        500.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 400.0,
      "bbox_min": [
        -409.5,
        1123.759033203125,
        400.0
      ],
      "bbox_max": [
        -379.50006103515625,
        1158.39990234375,
        400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1219.021728515625,
      "bbox_min": [
        -434.5,
        1101.0794677734375,
        60.0
      ],
      "bbox_max": [
        -144.5,
        1240.0,
        500.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1210.361328125,
      "bbox_min": [
        -434.5,
        1101.0794677734375,
        60.0
      ],
      "bbox_max": [
        -239.5,
        1219.021728515625,
        450.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 400.0,
      "bbox_min": [
        -429.4999084472656,
        1101.0794677734375,
        60.00611877441406
      ],
      "bbox_max": [
        -239.5,
        1210.361328125,
        450.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8660242557525635,
        0.5000020861625671,
        0.0
      ],
      "plane_d": -363.1293029785156,
      "bbox_min": [
        -279.5001220703125,
        1141.0794677734375,
        400.0
      ],
      "bbox_max": [
        -239.5,
        1210.361328125,
        450.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8661856651306152,
        0.4997224807739258,
        -0.0
      ],
      "plane_d": -362.76519775390625,
      "bbox_min": [
        -429.4999084472656,
        1158.39990234375,
        60.00611877441406
      ],
      "bbox_max": [
        -249.5,
        1210.361328125,
        120.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.6123719215393066,
        0.35355281829833984,
        0.7071074843406677
      ],
      "plane_d": -221.4859161376953,
      "bbox_min": [
        -429.4999084472656,
        1158.39990234375,
        60.00611877441406
      ],
      "bbox_max": [
        -387.95294189453125,
        1210.361328125,
        80.00611877441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 295.0,
      "bbox_min": [
        -434.5,
        1210.361328125,
        60.0
      ],
      "bbox_max": [
        -279.4776611328125,
        1219.021728515625,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6123719215393066,
        0.35355281829833984,
        0.7071074843406677
      ],
      "plane_d": -221.4859161376953,
      "bbox_min": [
        -434.5,
        1210.361328125,
        60.0
      ],
      "bbox_max": [
        -295.0,
        1219.021728515625,
        80.00611877441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 80.0,
      "bbox_min": [
        -345.0,
        1210.4000244140625,
        60.0
      ],
      "bbox_max": [
        -295.0,
        1219.021728515625,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3826870620250702,
        0.9238780736923218,
        -0.0
      ],
      "plane_d": -990.4848022460938,
      "bbox_min": [
        -345.0,
        1210.4000244140625,
        60.0
      ],
      "bbox_max": [
        -300.0,
        1215.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9060451984405518,
        0.4231809079647064,
        -0.0
      ],
      "plane_d": -204.16278076171875,
      "bbox_min": [
        -341.4644775390625,
        1210.4000244140625,
        60.0
      ],
      "bbox_max": [
        -340.0,
        1213.5355224609375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826870620250702,
        0.9238780736923218,
        0.0
      ],
      "plane_d": -1005.792236328125,
      "bbox_min": [
        -305.0,
        1210.4000244140625,
        60.0
      ],
      "bbox_max": [
        -300.0,
        1215.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9060451984405518,
        0.4231809079647064,
        0.0
      ],
      "plane_d": -240.40463256835938,
      "bbox_min": [
        -301.4644775390625,
        1210.4000244140625,
        60.0
      ],
      "bbox_max": [
        -300.0,
        1213.5355224609375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1210.4000244140625,
      "bbox_min": [
        -295.0,
        1210.361328125,
        80.0
      ],
      "bbox_max": [
        -279.4776611328125,
        1210.4000244140625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8661856651306152,
        0.4997224807739258,
        -0.0
      ],
      "plane_d": -362.76519775390625,
      "bbox_min": [
        -279.5,
        1210.361328125,
        80.0
      ],
      "bbox_max": [
        -279.4776611328125,
        1210.4000244140625,
        120.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.7069986462593079,
        0.7072150111198425
      ],
      "plane_d": -918.4239501953125,
      "bbox_min": [
        -434.5,
        1219.021728515625,
        60.0
      ],
      "bbox_max": [
        -144.5,
        1240.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6123719215393066,
        0.35355281829833984,
        0.7071074843406677
      ],
      "plane_d": -221.4859161376953,
      "bbox_min": [
        -434.5,
        1219.021728515625,
        60.0
      ],
      "bbox_max": [
        -295.0,
        1239.02783203125,
        80.00611877441406
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944272398948669,
        0.44721361994743347,
        -0.0
      ],
      "plane_d": -286.2166748046875,
      "bbox_min": [
        -299.513916015625,
        1230.0,
        60.0
      ],
      "bbox_max": [
        -295.0,
        1239.02783203125,
        69.02511596679688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944272398948669,
        0.44721361994743347,
        0.0
      ],
      "plane_d": -286.2167053222656,
      "bbox_min": [
        -340.0,
        1219.021728515625,
        60.0
      ],
      "bbox_max": [
        -295.0,
        1240.0,
        125.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 295.0,
      "bbox_min": [
        -340.0,
        1219.021728515625,
        60.0
      ],
      "bbox_max": [
        -295.0,
        1240.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1240.0,
      "bbox_min": [
        -340.0,
        1219.021728515625,
        60.0
      ],
      "bbox_max": [
        -295.0,
        1240.0,
        125.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 80.0,
      "bbox_min": [
        -340.0,
        1219.021728515625,
        80.0
      ],
      "bbox_max": [
        -295.0,
        1240.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": -109.99999237060547,
      "bbox_min": [
        -156.04698181152344,
        1158.39990234375,
        60.0
      ],
      "bbox_max": [
        120.0,
        1490.0,
        230.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 50.0,
      "bbox_min": [
        -156.04698181152344,
        1158.39990234375,
        60.0
      ],
      "bbox_max": [
        110.0,
        1430.0,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6122788190841675,
        0.35349908471107483,
        0.7072150111198425
      ],
      "plane_d": -399.0260009765625,
      "bbox_min": [
        -156.04698181152344,
        1158.39990234375,
        60.00611877441406
      ],
      "bbox_max": [
        -86.40599060058594,
        1239.021728515625,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.7069986462593079,
        0.7072150111198425
      ],
      "plane_d": -918.4239501953125,
      "bbox_min": [
        -156.04698181152344,
        1219.021728515625,
        60.00611877441406
      ],
      "bbox_max": [
        -132.95298767089844,
        1239.021728515625,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1270.0,
      "bbox_min": [
        0.0,
        1250.0,
        60.0
      ],
      "bbox_max": [
        110.0,
        1310.0,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1250.0,
      "bbox_min": [
        0.0,
        1250.0,
        60.0
      ],
      "bbox_max": [
        110.0,
        1270.0,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 80.0,
      "bbox_min": [
        0.0,
        1250.0,
        80.0
      ],
      "bbox_max": [
        110.0,
        1270.0,
        175.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.371390700340271,
        0.9284767508506775,
        0.0
      ],
      "plane_d": -1215.3760986328125,
      "bbox_min": [
        97.5,
        1265.0,
        80.0
      ],
      "bbox_max": [
        110.0,
        1270.0,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        10.0,
        1310.0,
        60.0
      ],
      "bbox_max": [
        110.0,
        1310.0,
        120.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8320503234863281,
        0.5547002553939819,
        0.0
      ],
      "plane_d": -793.2213134765625,
      "bbox_min": [
        110.0,
        1250.0,
        60.0
      ],
      "bbox_max": [
        120.0,
        1265.0,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1250.0,
      "bbox_min": [
        110.0,
        1250.0,
        60.0
      ],
      "bbox_max": [
        120.0,
        1265.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 80.0,
      "bbox_min": [
        110.0,
        1250.0,
        80.0
      ],
      "bbox_max": [
        120.0,
        1265.0,
        80.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [],
  "tutorial_messages": []
}